export default __webpack_public_path__ + "static/media/logo.49a5e07e.svg";